import Application from "../../Application";
import { ICaseLawDocument } from "../model/CaseLawDocument";
import { ICourtCase } from "../model/CourtCase";
import { IInvalidatedCaseLawDocument } from "../model/InvalidatedCaseLawDocument";
import { ICaseLawDocumentService } from "../service/CaseLawDocumentService";

export default class CreateCaseLawDocumentInteractor {
  private application: Application;
  private caseLawDocumentService: ICaseLawDocumentService;

  constructor({ application, caseLawDocumentService }: any) {
    this.application = application;
    this.caseLawDocumentService = caseLawDocumentService;
  }

  async execute(
    item: ICaseLawDocument,
    courtCases?: ICourtCase[],
    indexes?: number[],
    invalidatedCaseLawDocuments?: IInvalidatedCaseLawDocument
  ) {
    return this.caseLawDocumentService.createCaseLawDocument(
      item,
      courtCases,
      indexes,
      invalidatedCaseLawDocuments
    );
  }
}
